<template>
    <div>
        <upload :disabled="attachmentInfo.length > 4" is-main-corp @uploadComplete="uploadComplete" />
        <div v-for="(item, index) in attachmentInfo" :key="index" class="add-attachment">
            <file-view :upload-info="item" class="add-attachment-item" is-main-corp :attachment-info="attachmentInfo" @delete="deleteFile(index)" />
        </div>
    </div>
</template>
<script>
import upload from './file-upload.vue';
import fileView from './file-view.vue';
export default {
    components: {
        upload,
        fileView,
    },
    props: {
        eAttachment: {
            type: Object,
            default: () => ([]),
        },
    },
    data() {
        return {
            attachmentInfo: [],
        };
    },
    watch: {
        attachmentInfo(val) {
            this.$emit('changeAttachment', val.map(item => ({
                fileName: item.file_name,
                id: item.id,
                image: item.image,
            })));
        },
    },
    created() {
        this.attachmentInfo = this.eAttachment.map(item => ({
            file_name: item.fileName,
            ...item,
        }));
    },
    methods: {
        deleteFile(index) {
            this.attachmentInfo.splice(index, 1);
        },
        uploadComplete(res) {
            this.attachmentInfo.push({
                file_name: res.name,
                ...res,
                id: res.data,
            });
        },
    },
};
</script>
<style lang="less" scoped>
.add-attachment {
    width: 100%;
    &-item {
        width: 100%;
    }
}
</style>
